<template>
  <li class="nav-item dropdown" v-bind:class="{ show: isActive }">
    <a @click="isActive = !isActive;" class="nav-link dropdown-toggle text-muted waves-effect waves-dark" href="" data-toggle="dropdown" aria-haspopup="true" :aria-expanded="isActive == true">
        <i class="flag-icon" v-bind:class="this.flagName"></i></a>
    <div class="dropdown-menu dropdown-menu-right scale-up" v-bind:class="{ show: isActive }">
      <a v-bind:class="{ hidden: this.flagName == 'flag-icon-gb'}" class="dropdown-item" href="/switch-lang/en"><i class="flag-icon flag-icon-gb"></i> English</a>
      <a v-bind:class="{ hidden: this.flagName == 'flag-icon-it'}" class="dropdown-item" href="/switch-lang/it"><i class="flag-icon flag-icon-it"></i> Italiano</a>
    </div>
  </li>
</template>


<script>
    export default {
        mounted() {
          this.getCurrentLangIconClass();
        },

        data()  {
            return {
                isActive: false,
                flagName: this.current_lang,
                languages: ["en", "it"]
            }
        },

        methods: {
          getCurrentLangIconClass() {
            let flagName = this.current_lang;
            if (flagName === "en") flagName = "gb";
            this.flagName="flag-icon-"+flagName;
          }

        },
        created: function () {
        },
        props: {
          current_lang: {
            type: String,
            required: true,
          }

        }
    }
</script>
